import { render, staticRenderFns } from "./boundmerchant-detal.vue?vue&type=template&id=16d66d14&scoped=true"
import script from "./boundmerchant-detal.vue?vue&type=script&lang=js"
export * from "./boundmerchant-detal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d66d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d66d14')) {
      api.createRecord('16d66d14', component.options)
    } else {
      api.reload('16d66d14', component.options)
    }
    module.hot.accept("./boundmerchant-detal.vue?vue&type=template&id=16d66d14&scoped=true", function () {
      api.rerender('16d66d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/transport/bound/boundmerchant-detal.vue"
export default component.exports